<template>
  <div class="register">
    <div class="box">
      <div class="left">
        <img src="../assets/register/bg.png" alt />
      </div>
      <div class="right">
        <div class="title">
          <span></span>
          <h2>欢迎注册</h2>
        </div>
        <div class="regfrom" >
          <ul class="role" v-show="toshow">
            <li
              v-for="(item,index) in rolelist"
              :key="index"
              @click="changerole(index,item)"
              :class="{'active':current==index}"
            >{{item}}</li>
          </ul>
          <div :class="{'formbox':true,'addclass':isopen}">
            <a-form :form="form" ref="form" >
              <a-form-item>
                <a-input v-show="toshow"
                  v-decorator="[
                                  'user',
                                  { rules: [{ required: true, message: ' ' },{validator:validatoruser}] },
                                  ]"
                  placeholder="请输入用户名"
                >
                  <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  v-decorator="[
                                  'phone',
                                  { rules: [{ required: true, message: '请输入手机号' },{validator:validatorphone}] },
                                  ]"
                  placeholder="请输入手机号"
                >
                  <a-icon slot="prefix" type="phone" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item class="iteminp">
                <a-input
                  class="cadeinp"
                  v-decorator="[
                              'captcha',
                              { rules: [{ required: true, message: '请输入验证码' },{validator:validatorcaptcha}] },
                              ]"
                  placeholder="请输入短信验证码"
                >
                  <a-icon slot="prefix" type="text" style="color:rgba(0,0,0,.25)" />
                </a-input>
                <a-button v-if="show" class="subbtn" @click="gocade">
                  <span>获取验证码</span>
                </a-button>
                <a-button v-if="!show" class="subbtn">
                  <span class="count">{{count}}s</span>
                </a-button>
              </a-form-item>
              <a-form-item>
                <a-input
                  v-decorator="[
                              'pwd',
                              { rules: [{ required: true, message: '请输入密码' },{validator:validatorPwd}] },
                              ]"
                  type="password"
                  placeholder="请输入8-16位新密码，区分大小写"
                >
                  <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  v-decorator="[
                              'repwd',
                              { rules: [{ required: true, message: '请确认密码' },{validator:validatorrePwd}] },
                              ]"
                  type="password"
                  placeholder="确认新密码"
                >
                  <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item class="reginp">
                <a-button class="regbtn" type="primary" @click="toreg">注册</a-button>
              </a-form-item>
              <!-- <p class="tpxieyi" >注册即代表我已阅读并同意<a href="www.baidu.com" target="_brank">《用户服务协议及隐私政策》</a></p> -->
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <div class="Box" v-if="isBox">
      <div class="boxModel">
        <div class="header"></div>
        <div class="info">
          <p class="mod">
            <img src="../assets/register/chenggong.png" alt />
            <span>注册成功！</span>
          </p>
          <div class="close" @click="closeModal">X</div>
        </div>
        <div class="content">
          <p>恭喜你，注册成功！</p>
          <div class="sub">
            <button class="minebtn" @click="tobasicInfo">去完善个人中心</button>
            <button class="closebtn" @click="closeModal">以后再说</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getcodeApi, getregister, getcheckPhoneApi,userLoginApi} from "@/request/api";
export default {
  name: "register",
  data() {
    let validatoruser = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.username = value;
          callback();
        } else {
          callback(new Error("请输入用户名"));
        }
      } else {
          callback(new Error("请输入用户名"));
      }
    };
    let validatorphone = (rule, value, callback) => {
      var regphone = /^1[3456789]\d{9}$/;
      if (value == "" || regphone.test(value)) {
        this.phone = value;
        callback();
      } else {
        callback(new Error("请输入正确格式的手机号"));
      }
    };
    let validatorPwd = (rule, value, callback) => {
      var regpwd = /^[\w$]{8,16}$/; //所有字符验证
      if (value == "" || regpwd.test(value)) {
        this.pwd = value;
        callback();
      } else {
        callback(new Error("密码格式错误，请输入8到16位密码，区分大小写"));
      }
    };
    let validatorcaptcha = (rule, value) => {
      this.captcha = value;
    };
    let validatorrePwd = (rule, value, callback) => {
      this.repwd = value;
      if (value == this.pwd) {
        callback();
      } else {
        callback(new Error("两次密码不一致"));
      }
    };
    return {
      left:0,
      validatorphone,
      validatoruser,
      validatorPwd,
      validatorrePwd,
      validatorcaptcha,
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      rolelist: ["学生", "教师"],
      regIndex: "",
      current: "",
      currentindex:'',
      toshow: true,
      isshow: false,
      isbg: true,
      isbig: false,
      phone: "",
      captcha: "",
      pwd: "",
      username: "",
      show: true,
      count: "",
      timer: null,
      role:"学生",
      isBox: false,
      repwd: "",
      isopen:false,
    };
  },
  methods: {
    torole() {
      //控制左边的背景
      this.isbg = true;
      this.isbig = false;
      //控制角色切换
      this.toshow = true;
      this.isshow = false;
      this.role="学生"
    },
    tobrole() {
      //控制左边的背景
      this.isbg = false;
      this.isbig = true;
      //控制角色切换
      this.toshow = false;
      this.isshow = true;
      this.role="学校"
    },
    //切换个人用户
    changerole(index, title) {                
      this.current = index;
      
      this.isopen=!this.isopen
      setTimeout(()=>{this.isopen=false},300)
      // console.log(this.isopen)
      if (title == "学生") {
        this.role = "学生";
        this.show = true;
        this.$refs.form.form.resetFields(["user"]);
        this.$refs.form.form.resetFields(["phone"]);
        this.$refs.form.form.resetFields(["captcha"]);
        this.$refs.form.form.resetFields(["pwd"]);
        this.$refs.form.form.resetFields(["repwd"]);
        // console.log(this.role)
      } else if(title == "教师") {
        this.role = "教师";
        this.show = true;
        this.$refs.form.form.resetFields(["user"]);
        this.$refs.form.form.resetFields(["phone"]);
        this.$refs.form.form.resetFields(["captcha"]);
        this.$refs.form.form.resetFields(["pwd"]);
        this.$refs.form.form.resetFields(["repwd"]);
        // console.log(this.role)
      }
    },
    //验证码
    gocade() {
      if (this.phone) {
        this.getToken(getcheckPhoneApi, { telephone: this.phone }, (res) => {
          if (res.isExist == false) {
            this.getToken(getcodeApi, { telephone: this.phone }, (res) => {
              if (res.code == 200) {
                this.$message.info("验证码已发送，请注意查收！");
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                }
              }
            });
          } else {
            this.$message.error("手机号码已注册！");
          }
        });
      } else {
        this.$message.error("请输入手机号");
      }
    },
    //注册
    toreg() {
      if (this.username) {
        if (this.phone) {
          if (this.pwd) {
            if (this.pwd === this.repwd) {
              this.getToken(
                getregister,
                {
                  telephone: this.phone,
                  username: this.username,
                  captcha: this.captcha,
                  password: this.pwd,
                  role: this.role,
                },
                (res) => {
                  if (res.code == 200) {
                    this.getToken(userLoginApi,{"account":this.phone,"password":this.pwd},value=>{
                       if(value.code==200){
                            localStorage.setItem("isLogin", 0);
                            localStorage.setItem("role", value.data.role);
                            localStorage.setItem("username", value.data.name);
                            localStorage.setItem("icon", value.data.icon);
                            localStorage.setItem("token", value.data.token);
                            localStorage.setItem("loginTime",new Date().getTime())
                            localStorage.setItem("authentation", value.data.authentation);
                            this.$store.commit("toggleIsLogin", {
                              isLogin: 0,
                              role: value.data.role,
                              username: value.data.name,
                              icon: value.data.icon,
                              authentation: value.data.authentation,
                          });
                            this.$message.success("注册成功");
                       }
                    })
                    this.isBox = true;
                  }
                }
              );
            } else {
              this.$message.error("两次密码不一致");
            }
          } else {
            this.$message.error("密码不能为空");
          }
        } else {
          this.$message.error("手机号码不能为空");
        }
      } else this.$message.error("用户名不能为空");
    },
    //个人中心
    tobasicInfo() {
      this.$router.push({ path: "/basicInfo" });
    },
    //关闭弹窗，去首页
    closeModal() {
      this.isBox = false;
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style lang="stylus" scoped>
@keyframes mymove{
  0%{-webkit-transform:rotateY(0deg);}
  100%{-webkit-transform:rotateY(360deg);}
}
.addclass{
   animation:mymove 0.3s;
}
.register {
  background: #fff;
  border: 1px solid #ccc;
  .box {
    margin: 0 auto;
    width: 1205px;
    display: flex;
  }
  .left {
    width: 456px;
    height: 716px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    margin-left: 65px;
    width:615px;
    overflow hidden
    .title{
      width:615px;
      margin-top:28px;
      height: 40px;
      display:flex;
      align-items center;
	    background-color: #f6f6f6;
      span{
        width:5px;
        height:22px;
        background:#f0cd48
      }
      h2{
        font-size:22px;
        color:#333;
        height:22px;
        margin-left:8px;
      }
    }
    .regfrom {
      min-height: 500px;
      // margin-top:50px;
      width: 420px;
      margin:50px auto;
      .role {
        width: 420px;
        display: flex;
        margin-bottom: 35px;
        display: flex; 
        li {
          width: 140px;
          text-align: center;
          color: #666666;
          font-size: 18px;
          line-height: 37px;
          border-bottom: 1px solid #dddddd;
          font-weight: 900;
          flex: 1;
          cursor pointer
        }
        .active {
          letter-spacing: 0px;
          color: #ef9545;
          border-bottom: 1px solid #ef9545;
        }
      }
      .formbox {
        width: 420px;
        margin: 0 auto;
        margin-top: 60px;
        transform: rotateY(0deg);
        .ant-btn-primary {
          height: 45px;
          width: 420px;
          background-color: #f0cd48;
          border-radius: 3px;
          font-size: 18px;
          border: 0;
          color:#333;
        }
        .ant-input-affix-wrapper {
          line-height: 45px;
          height: 45px;
        }
        .iteminp {
          display: flex;
          .cadeinp {
            width: 290px;
            margin-right: 10px;
            padding-left: -10px;
          }
          .subbtn {
            width: 118px;
            height: 45px;
            line-height: 45px;
            background: #ffffff;
            border-radius: 3px;
            border: solid 1px #ef9545;
            color: #ef9545;
            outline: none;
            .count {
              color: red;
            }
          }
        }
        .reginp {
          display: flex;
          .regbtn {
            width: 420px;
            height: 44px;
            border-radius: 3px;
            background:#f0cd48;
          }
        }
        .tpxieyi{
          margin-top:20px;
          color:#a7a7a7;
          font-size:16px
          a{
            color:#a7a7a7;
            text-decoration:underline;
          }
          a:hover{
            color:#f0cd48;
            text-decoration:underline;
          }
        }
      }
    }
  }

  .Box {
    position: relative;
    z-index: 999;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba(0, 0, 0, 0.5);

    .boxModel {
      width: 489px;
      height: 246px;
      background-color: #ffffff;
      border-radius: 3px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .header {
        width: 100%;
        height: 5px;
        background-color: #0096ff;
      }

      .info {
        .mod {
          margin: 0 auto;
          width: 420px;
          border-bottom: 1px solid #dfdfdf;
          height: 70px;
          line-height: 70px;
          display: flex;
          align-items: center;
          position: relative;

          img {
            width: 32px;
            height: 32px;
          }

          span {
            color: #666666;
            font-size: 18px;
            padding-left: 11px;
          }
        }

        .close {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #999;
          font-size: 22px;
          position: absolute;
          right: 15px;
          top: 15px;
          cursor: pointer;
        }
      }

      .content {
        p {
          width: 420px;
          margin: 0 auto;
          padding-top: 25px;
          font-size: 16px;
          margin-bottom: 40px;
        }

        .sub {
          background: pink;
          display: flex;
          position: relative;

          .minebtn {
            background-color: #f0cd48;
            border-radius: 3px;
            color: #fff;
            border: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            outline: none;
            font-size: 16px;
            position: absolute;
            right: 144px;
            width: 138px;
            height: 36px;
          }
          .closebtn {
            border: 1px solid #f0cd48;
            background: #fff;
            color: #f0cd48;
            border-radius: 3px;
            outline: none;
            position: absolute;
            right: 36px;
            height: 36px;
            width: 93px;
          }
        }
      }
    }
  }
}
</style>
